import { DvToolbarAction, DvGridComponent } from '@devinco/ui/grid';
import { Directive, OnInit, inject } from '@angular/core';
import { GridContext } from '@features/vt-grid/interfaces/grid-context';
import { TranslateService } from '@ngx-translate/core';

/** Common logic for all `dv-grid`'s
 *
 * **Features:**
 * - Translate toolbar actions
 * - Translate clear all filters text
 * - Translate search placeholder
 */
@Directive({
  selector: 'dv-grid',
  standalone: false,
})
export class DvGridDirective implements OnInit {
  private grid = inject(DvGridComponent);
  private translate = inject(TranslateService);

  ngOnInit(): void {
    this.grid.clearFilterText.set(
      this.translate.instant('Grid.ClearAllFilters')
    );
    this.grid.searchPlaceholder.set(this.translate.instant('Grid.searchOoo'));
    this.grid.actions()?.forEach((action: DvToolbarAction) => {
      if (action.buttonTextKey) {
        action.buttonText = this.translate.instant(action.buttonTextKey);
      }
      this.translateTooltip(action, action.tooltipKey ?? action.tooltip ?? '');
      if (action.menuItems?.length) {
        action.menuItems.forEach((item: any, index: number) => {
          action.menuItems![index] = {
            ...item,
            label: this.translate.instant(item.labelKey || ''),
          };
        });
      }

      if (action.icon === 'delete') {
        // needed to make sure that grid is ready
        setTimeout(() => {
          (this.grid.context as GridContext).rowDeleteFn = action.clickFn;
        }, 300);
      }
    });
  }

  private translateTooltip(
    action: DvToolbarAction,
    translateKey: string
  ): void {
    if (!translateKey) return;

    action.tooltip = this.translate.instant(translateKey);
  }
}
